// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SuggestedKeywords_suggestedKeywordsContainer__qWKMT {
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  border-radius: 12px;
  border: 1px solid var(--accent-color-light);
  background-color: var(--background-color-2);
}
.SuggestedKeywords_suggestedKeywordsContainer__qWKMT .SuggestedKeywords_title__DvAjd {
  display: flex;
  align-items: center;
  gap: 4px;
  color: var(--text-1);
  text-align: center;
  font-family: "Lora", "Roboto", "Helvetica", "Arial", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.SuggestedKeywords_suggestedKeywordsContainer__qWKMT .SuggestedKeywords_title__container__Zt6Ro {
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
}
.SuggestedKeywords_suggestedKeywordsContainer__qWKMT .SuggestedKeywords_show-more-button__LSd9O {
  border-bottom: 1px solid var(--info-color);
  color: var(--info-color);
  border-radius: 0;
  text-transform: initial;
  padding-bottom: 3px;
  font-family: "Lora", "Roboto", "Helvetica", "Arial", sans-serif;
}
.SuggestedKeywords_suggestedKeywordsContainer__qWKMT .SuggestedKeywords_suggested-keyword--list__15AV0 {
  height: 127px;
  overflow: hidden;
  display: flex;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  flex-wrap: wrap;
}
.SuggestedKeywords_suggestedKeywordsContainer__qWKMT .SuggestedKeywords_suggested-keyword--item__T0sXS {
  display: flex;
  padding: 8px 12px;
  align-items: center;
  border-radius: 8px;
  background: var(--accent-color-light);
  color: var(--text-1);
  text-align: center;
  font-family: "Lora", "Roboto", "Helvetica", "Arial", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  box-shadow: none;
  text-transform: initial;
}
.SuggestedKeywords_suggestedKeywordsContainer__qWKMT .SuggestedKeywords_suggested-keyword--item__T0sXS:hover {
  background: var(--accent-color);
  color: var(--text-0);
}

.SuggestedKeywords_noResultsMessage__c1GIw {
  margin-bottom: 12px;
}

.SuggestedKeywords_keywordsCard__B7qyc {
  background-color: #f0f5ff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.SuggestedKeywords_keywordsContent__aWOip {
  width: 100%;
}

.SuggestedKeywords_suggestedKeywordsTitle__T9yzf {
  color: var(--secondary-color);
  margin-bottom: 8px !important;
  font-size: 14px;
}
.SuggestedKeywords_suggestedKeywordsTitle__T9yzf .SuggestedKeywords_anticon__aLlcc {
  margin-right: 4px;
}

.SuggestedKeywords_keywordsList__vQOMK {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.SuggestedKeywords_keywordTag__Z7Igp {
  cursor: pointer;
  font-size: 12px;
  padding: 2px 6px;
  border-radius: 12px;
  transition: all 0.3s;
  background-color: #f0f0f0;
  color: #595959;
  border: 1px solid #d9d9d9;
}
.SuggestedKeywords_keywordTag__Z7Igp:hover {
  background-color: #e6e6e6;
  border-color: #bfbfbf;
}

@media (max-width: 576px) {
  .SuggestedKeywords_suggestedKeywordsContainer__qWKMT {
    padding: 8px;
  }
  .SuggestedKeywords_suggestedKeywordsContainer__qWKMT .SuggestedKeywords_title__DvAjd {
    font-size: 14px;
  }
  .SuggestedKeywords_keywordsList__vQOMK {
    gap: 4px;
  }
  .SuggestedKeywords_keywordTag__Z7Igp {
    font-size: 11px;
    padding: 1px 5px;
  }
}
.SuggestedKeywords_moreKeywordsHint__QI0Y4 {
  font-size: 12px;
  color: #8c8c8c;
  margin-top: 8px;
}`, "",{"version":3,"sources":["webpack://./src/Explore/Components/SuggestedKeywords/SuggestedKeywords.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;EACA,mBAAA;EACA,2CAAA;EACA,2CAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,oBAAA;EACA,kBAAA;EACA,+DAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AACJ;AACI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AACN;AAGE;EACE,0CAAA;EACA,wBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,+DAAA;AADJ;AAKI;EACE,aAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,eAAA;AAHN;AAMI;EACE,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,qCAAA;EACA,oBAAA;EACA,kBAAA;EACA,+DAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAJN;AAMM;EACE,+BAAA;EACA,oBAAA;AAJR;;AAUA;EACE,mBAAA;AAPF;;AAUA;EACE,yBAAA;EACA,kBAAA;EACA,yCAAA;AAPF;;AAUA;EACE,WAAA;AAPF;;AAUA;EACE,6BAAA;EACA,6BAAA;EACA,eAAA;AAPF;AASE;EACE,iBAAA;AAPJ;;AAWA;EACE,aAAA;EACA,eAAA;EACA,QAAA;AARF;;AAWA;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,oBAAA;EACA,yBAAA;EACA,cAAA;EACA,yBAAA;AARF;AAUE;EACE,yBAAA;EACA,qBAAA;AARJ;;AAYA;EACE;IACE,YAAA;EATF;EAUE;IACE,eAAA;EARJ;EAYA;IACE,QAAA;EAVF;EAaA;IACE,eAAA;IACA,gBAAA;EAXF;AACF;AAcA;EACE,eAAA;EACA,cAAA;EACA,eAAA;AAZF","sourcesContent":[".suggestedKeywordsContainer {\n  display: flex;\n  padding: 16px;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 16px;\n  align-self: stretch;\n  border-radius: 12px;\n  border: 1px solid var(--accent-color-light);\n  background-color: var(--background-color-2);\n\n  .title {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    color: var(--text-1);\n    text-align: center;\n    font-family: \"Lora\", \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n\n    &__container {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      align-self: stretch;\n    }\n  }\n\n  .show-more-button {\n    border-bottom: 1px solid var(--info-color);\n    color: var(--info-color);\n    border-radius: 0;\n    text-transform: initial;\n    padding-bottom: 3px;\n    font-family: \"Lora\", \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n  }\n\n  .suggested-keyword {\n    &--list {\n      height: 127px;\n      overflow: hidden;\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      align-self: stretch;\n      flex-wrap: wrap;\n    }\n\n    &--item {\n      display: flex;\n      padding: 8px 12px;\n      align-items: center;\n      border-radius: 8px;\n      background: var(--accent-color-light);\n      color: var(--text-1);\n      text-align: center;\n      font-family: \"Lora\", \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: normal;\n      box-shadow: none;\n      text-transform: initial;\n\n      &:hover {\n        background: var(--accent-color);\n        color: var(--text-0);\n      }\n    }\n  }\n}\n\n.noResultsMessage {\n  margin-bottom: 12px;\n}\n\n.keywordsCard {\n  background-color: #f0f5ff;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n}\n\n.keywordsContent {\n  width: 100%;\n}\n\n.suggestedKeywordsTitle {\n  color: var(--secondary-color);\n  margin-bottom: 8px !important;\n  font-size: 14px;\n\n  .anticon {\n    margin-right: 4px;\n  }\n}\n\n.keywordsList {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.keywordTag {\n  cursor: pointer;\n  font-size: 12px;\n  padding: 2px 6px;\n  border-radius: 12px;\n  transition: all 0.3s;\n  background-color: #f0f0f0;\n  color: #595959;\n  border: 1px solid #d9d9d9;\n\n  &:hover {\n    background-color: #e6e6e6;\n    border-color: #bfbfbf;\n  }\n}\n\n@media (max-width: 576px) {\n  .suggestedKeywordsContainer {\n    padding: 8px;\n    .title {\n      font-size: 14px;\n    }\n  }\n\n  .keywordsList {\n    gap: 4px;\n  }\n\n  .keywordTag {\n    font-size: 11px;\n    padding: 1px 5px;\n  }\n}\n\n.moreKeywordsHint {\n  font-size: 12px;\n  color: #8c8c8c;\n  margin-top: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"suggestedKeywordsContainer": `SuggestedKeywords_suggestedKeywordsContainer__qWKMT`,
	"title": `SuggestedKeywords_title__DvAjd`,
	"title__container": `SuggestedKeywords_title__container__Zt6Ro`,
	"show-more-button": `SuggestedKeywords_show-more-button__LSd9O`,
	"suggested-keyword--list": `SuggestedKeywords_suggested-keyword--list__15AV0`,
	"suggested-keyword--item": `SuggestedKeywords_suggested-keyword--item__T0sXS`,
	"noResultsMessage": `SuggestedKeywords_noResultsMessage__c1GIw`,
	"keywordsCard": `SuggestedKeywords_keywordsCard__B7qyc`,
	"keywordsContent": `SuggestedKeywords_keywordsContent__aWOip`,
	"suggestedKeywordsTitle": `SuggestedKeywords_suggestedKeywordsTitle__T9yzf`,
	"anticon": `SuggestedKeywords_anticon__aLlcc`,
	"keywordsList": `SuggestedKeywords_keywordsList__vQOMK`,
	"keywordTag": `SuggestedKeywords_keywordTag__Z7Igp`,
	"moreKeywordsHint": `SuggestedKeywords_moreKeywordsHint__QI0Y4`
};
export default ___CSS_LOADER_EXPORT___;
